module.exports = __webpack_public_path__ + "img/heading_no.092de9e1.svg";